function initRelatedProducts() {
  const relatedProducts = document.querySelector('[data-related-products]');
  const relatedProductsSlider = document.querySelector('[data-related-products-carousel]');

  if (! relatedProducts) return;

  const swiper = new Swiper(relatedProductsSlider, {
      slidesPerView: 1,
      cenderedSlides: !0,
      spaceBetween: 25,
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
      },
      breakpoints: {
          750: {
              slidesPerView: 2,
              centeredSlides: !1,
              spaceBetween: 16
          },
          1025: {
              slidesPerView: 3,
              centeredSlides: !1,
              spaceBetween: 24
          }
      }
  });

  window.addEventListener('scroll', toggleActiveState(relatedProducts));
  document.addEventListener('DOMContentLoaded', toggleActiveState(relatedProducts));
  document.addEventListener('shopify:section:load', toggleActiveState(relatedProducts));
}

function toggleActiveState(relatedProducts) {
  if (relatedProducts.classList.contains('active')) return;

  const relatedProductsOffsetTop = relatedProducts.offsetTop;

  window.scrollY + window.innerHeight <= relatedProductsOffsetTop || relatedProducts.classList.add('active');
}

document.addEventListener('DOMContentLoaded', initRelatedProducts());

document.addEventListener('shopify:section:load', initRelatedProducts());
